import actionTypes from '../constants/action-types';

const isLoaded = (state = false, action) => {
  if (action.type !== actionTypes.SET_LOADED_STATUS) return state;
  return action.payload;
};

export default isLoaded;
